var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 7.47,
    x: 4.5,
    y: 4.5,
    stroke: "#fff",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.5,
    height: 4.5,
    x: 4.5,
    y: 15,
    stroke: "#fff",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.5,
    height: 4.5,
    x: 13,
    y: 15,
    stroke: "#fff",
    rx: 0.5
  })));
};
export { SvgGrid as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxyZWN0IHg9IjQuNSIgeT0iNC41IiB3aWR0aD0iMTUiIGhlaWdodD0iNy40NyIgcng9Ii41IiBzdHJva2U9IiNmZmYiLz48cmVjdCB4PSI0LjUiIHk9IjE1IiB3aWR0aD0iNi41IiBoZWlnaHQ9IjQuNSIgcng9Ii41IiBzdHJva2U9IiNmZmYiLz48cmVjdCB4PSIxMyIgeT0iMTUiIHdpZHRoPSI2LjUiIGhlaWdodD0iNC41IiByeD0iLjUiIHN0cm9rZT0iI2ZmZiIvPjwvc3ZnPg==";